import React from 'react'
import './MenuItemDivider.less'

const MenuItemDivider = () => <div className="CasePageMenuItemDivider" />

export default MenuItemDivider
